export const Mark = ({ className = "", onDark = false }) => (
  <img
    src="/logo-emblem.png"
    alt="Three Abide Ministries emblem"
    className={`${className} object-contain ${onDark ? "" : "logo-blend"}`}
    draggable="false"
  />
);
